/* Bio Link Page slot tracking for Lara's Mahjong Edit
   ---------------------------------------------------
   Fires a GA4 bio_card_click event on every element carrying data-bio-slot.
   GA4 (property 522354197) is already installed on the theme via the native
   Google channel gtag. We do NOT install a second tag here.

   Internal links carry NO UTM params (the bio link itself carries them; the
   GA4 session already knows it came from Instagram). Only ShopMy (external)
   keeps UTMs, set in the markup. This script only reports which slot was clicked.
*/
(function () {
  function init() {
    var els = document.querySelectorAll('[data-bio-slot]');
    if (!els.length) return;
    els.forEach(function (el) {
      el.addEventListener('click', function () {
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'bio_card_click', {
            slot: el.dataset.bioSlot,
            link_url: el.href || (el.getAttribute('href') || '')
          });
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
